/**
 * Resource danh mục Chương trình mục tiêu, dự án
 * VDDONG 23/05/2023
 */
export default {
  Add: 'Thêm',
  NavLinkItem: 'Danh mục',
  RouterNavLink: ' Mục lục ngân sách / Chương trình mục tiêu, dự án',
  InputSearchPlaceholder: 'Tìm kiếm theo Mã, Tên CTMT, Dự án',
  RefreshData: 'Lấy lại dữ liệu',
  Print: 'In',
  Help: 'Trợ giúp',
  ViewEdit: 'Xem/Sửa',
  Follow: 'Theo dõi',
  Unfollow: 'Ngừng theo dõi',
  Delete: 'Xóa',
  Save: 'Cất',
  Cancel: 'Hủy',
  TooltipSave: 'Cất (Ctrl + S)',
  Follow: 'Theo dõi',
  ProjectList: {
    Title: 'Chương trình mục tiêu, dự án',
  },
  ProjectTarget: {
    ProjectCode: 'Mã CTMT *',
    ProjectName: 'Tên CTMT *',
    ParentCode: 'Thuộc CTMT',
    LabelProjectCode: 'Mã Chương trình mục tiêu',
    LabelProjectName: 'Tên Chương trình mục tiêu',
    LabelParentCode: 'Thuộc Chương trình mục tiêu',
    Title: 'Chương trình mục tiêu',
    EditTitle: 'Sửa chương trình mục tiêu',
  },
  ProjectDetail: {
    ProjectCode: 'Mã dự án *',
    ProjectNumber: 'Số hiệu dự án *',
    ProjectName: 'Tên dự án *',
    ParentCode: 'Thuộc CTMT, dự án',
    StartDate: 'Ngày bắt đầu',
    FinishDate: 'Ngày kết thúc',
    DepartmentName: 'Phòng ban',
    ExecutionUnit: 'Đơn vị thực hiện',
    TotalAmountApproved: 'Tổng kinh phí được duyệt',
    LabelParentCode: 'Thuộc Chương trình mục tiêu, dự án',
    Title: 'Dự án',
    FormatTitle: 'CTMT, dự án',
    EditTitle: 'Sửa dự án',
  },
  ProjectConstruction: {
    GeneralInfo: 'Thông tin chung',
    Estimate: 'Dự toán',
    BudgetSource: 'Nguồn vốn',
    Contract: 'Hợp đồng',
    ProjectCode: 'Mã *',
    ProjectName: 'Tên *',
    ParentCode: 'Thuộc dự án *',
    ParentCodeConstruction: 'Thuộc công trình *',
    StartDate: 'Ngày bắt đầu',
    FinishDate: 'Ngày kết thúc',
    TotalAmountApproved: 'Dự toán',
    ConstructorCode: 'Nhà thầu',
    ConstructorAddress: 'Địa chỉ',
    InvestmentClass: 'Cấp quyết định đầu tư',
    BuildLocation: 'Địa điểm xây dựng',
    ProjectSize: 'Quy mô công trình',
    PreviousYearAmount: 'Giá trị thực hiện năm trước',
    Description: 'Diễn giải',
    Title: 'Công trình/ HMCT',
    FormatTitle: 'Dự án',
    EditTitle: 'Sửa chương trình mục tiêu, dự án',
  },
};
